export default {
  data() {
    return {

    }
  },
  components: {

  },
  methods:
  {

  },
  mounted () {

    //scroll to 0 if page has no hash
    if(this.$route.hash === "")
    {
        document.documentElement.scrollTop = 0;
    }

    setTimeout( () => {
      if(this.$route.hash.toLowerCase() === "#contact")
      {
        const c = document.querySelector( '.Contact_form' );
        if( c )
        {
          const p = c.getBoundingClientRect();
          document.documentElement.scrollTop = p.top - 80;
        }
      }
    }, 500)
  }

}
